import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {Button, Form} from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import {getLeadByID, gotFineDoneResponsible} from '../../redux/reduxActions/leadActions';
import {setObjectiveSelector, showToastError} from '../utils';

const FineDone = (props) => {
    const { selectedLead, responsible } = props;
    const [changeResponsible,setChangeResponsible] = useState(false);
    const [comment, setComment] = useState();
    const [responsibleState, setResponsible] = useState('');
    useEffect(() => {
        props.getLeadByID(props.match.params.id);
    }, []);
    const responsiblePerson = () => {
        const type = Object.entries(props.responsible)
            .find((el) => parseInt(el[0], 10) === selectedLead.responsible);
        if (!type) {
            return '-';
        }
        return type[1];
    };
    function gotFineDoneApply() {
            props.gotFineDoneResponsible(selectedLead.id, {comment, responsible: responsibleState}, props.history.push);
    }
    return (
        <div>
            <div>
                <div className="lead__container" style={{ minHeight: 'auto' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', margin: 15 }}>
                        <h3 style={{ color: '#383838', marginBottom: 0, height: 'min-content' }}>
                            Fine Done
                        </h3>
                        <div
                            className="lead__container_buttons"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-around',
                                width: '200px'
                            }}
                        >
                            <Button
                                onClick={() => window.history.back()}
                                size="sm"
                                id="apply-filter"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => { gotFineDoneApply();}}
                                size="sm"
                                id="apply-filter"
                            >
                                Apply
                            </Button>
                        </div>
                    </div>
                    <div
                        style={{
                            display:'flex',
                            flexWrap: 'wrap',
                            margin: 20
                        }}
                    >
                        <p>Do you want to change the responsible person ?</p>
                        <div
                            style={{
                                paddingTop:'3px',
                                paddingLeft:'20px',
                                paddingRight:'10px'
                            }}
                        >
                            <input onChange={() => setChangeResponsible(!changeResponsible)} type="checkbox" id="scales" name="scales"  />
                        </div>
                    </div>
                    <div className="lead__container__inner"
                         style={{
                             paddingTop:'3px',
                             paddingLeft:'20px',
                             paddingRight:'10px',
                             display: 'flex',
                             flexWrap: 'wrap'
                         }}
                    >
                        <p className="lead__title">
                            Responsible
                        </p>
                        <Form.Group style={{ width: '50%'}} controlId="formGridState">
                            <Form.Control disabled={!changeResponsible} as="select" onChange={({ target }) => setResponsible(target.value)}>
                                <option key="" value="">{responsiblePerson()}</option>
                                {setObjectiveSelector(responsible)}
                            </Form.Control>
                        </Form.Group>
                    </div>
                    <TextareaAutosize
                        onChange={({ target: { value } }) => { setComment(value); }}
                        className="lead_input__first-message"
                        rows={3}
                        placeholder="..."
                    />
                </div>
            </div>
        </div>
    );
};
export default connect((state) => ({
    responsible: state.leadReducer.responsible,
    selectedLead: state.leadReducer.selectedLead,
}),{getLeadByID, gotFineDoneResponsible})(FineDone);